import { FormControl, ValidatorFn, AsyncValidatorFn, AbstractControlOptions } from '@angular/forms';
import { VisumErfassungSubFormComponent } from '../../components/visum-erfassung/visum-erfassung-sub-form/visum-erfassung-sub-form.component';

export class FormSubGroupControl extends FormControl {
  _valueAccessor: VisumErfassungSubFormComponent;

  constructor(formState?: any, validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null, asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null){
    super(formState, validatorOrOpts, asyncValidator);
  }

  _forEachChild(callback: Function) {
    // console.log('ForEach', this, this._valueAccessor);
    if (this._valueAccessor) {
      callback(this._valueAccessor.form);
    }
  }
}
